var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Alert, Box, CircularProgress, Divider, Grid, Menu, MenuItem, MenuList, Slider, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import moment from "moment";
import { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { UploadImage } from '../../../api/api';
import { Config } from "../../../api/config";
import { approvalEstimate, createAttachment, createJobcardURL, estimateCreateUrl, getDownloadPreJobCardDocumentAttachmentUrl, getEstimateAdditionalDetailByEstimateIdUrl, getEstimateProductContitionValuesUrl, getInspectionApprovalTypeUrl, precheckDynamicCheckListFormUrl, previousJobCardURLForRepeat, productAttributeValueUrl, UploadedSignAttachmentUrl, ValidateServiceTypeURL } from '../../../api/url';
import { AlertRedIcon, SuccessIconNew, WarningIcon } from '../../../assets/images';
import useRbacController from "../../../builderPackage/rbac/useRbacController";
import { MuiBorderBottom, MuiPopup, MuiStack } from '../../../components';
import HeaderDetails from '../../../components/atoms/headerDetails';
import { MuiLoaderButton } from "../../../components/atoms/loaderButton";
import SkeletonLoader from "../../../components/atoms/sketeton";
import CancelSuccessfullyPopup from '../../../components/molecules/cancelSuccessfullyPopup';
import CancelDocumentModal from '../../../components/templates/cancelDocumentModal';
import EditCustomerInfo from '../../../components/templates/editCustomerInfo';
import { ECancelDocSystemName, EListCardView, EMenuFeature, EMenuNames, EModuleSection, EParentModuleName, EUserRole, E_Channel_Name, InPerson, isModuleConfig, LOCAL_STORAGE_KEYS, Module, StatusEnum } from '../../../constants';
import { downloadAttachment, showLoader, showNotification } from '../../../redux/commonSlice';
import { createAPI, getByIdAPI, getListAPI, setState, updateAPI } from '../../../redux/crudSlice';
import { socketIO } from "../../../socket";
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { gray } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { calculateTimeDifference, getLocalStorageItem, setLocalStorageItem } from '../../../utils/storageHelper';
import useAnalyticsEventTracker from "../../../utils/useAnalyticsEventTracker";
import { dateFormate, getCTAList, getprecheckSectionAttributes, getTime, GoogleAnlyticsErrorLog, minutesOfDay, scrollToTop, transactionEventLog } from '../../../utils/utils';
import CustomerAndVehicleInfo from "../../commonViews/searchByType/customerAndVehicleInfo";
import OptionAlert from "../../jobCard/repeat/optionsAlert";
import { NewServiceEstimatePrint } from "../../prints/components/newServiceEstimatePrint";
import { printFeature } from "../../prints/services/entity";
import MultipleAccordianCard from './multipleAccordianCard';
import ServiceEstimatePreCheckAndCustomerApproval from './serviceEstimate.preCheckAndCustomerApproval';
import AppointmentAssignReassignPopup from "../../../components/templates/AppointmentAssignReassignPopup";
import { calculateEstimateCost } from "./serviceEstimateUtils";
import UnsavedChangesPopup from "../../../components/molecules/unsavedChangesPopup";
export default function EstimateDetailsView(props) {
    var _this = this;
    var _documentDetailsGetBy, _getLocalStorageItem, _documentDetailsGetBy13, _documentDetailsGetBy14, _documentDetailsGetBy15, _documentDetailsGetBy16, _documentDetailsGetBy17, _documentDetailsGetBy18, _documentDetailsGetBy19, _documentDetailsGetBy20, _documentDetailsGetBy21, _documentDetailsGetBy22, _documentDetailsGetBy23, _documentDetailsGetBy24, _documentDetailsGetBy25, _documentDetailsGetBy26, _documentDetailsGetBy27, _documentDetailsGetBy28, _documentDetailsGetBy29, _rbacControl$MarkAppr, _rbacControl$MarkAppr2, _documentDetailsGetBy30, _approvalData$SourceM7, _approvalData$SourceM8, _getCustomerInfo$data, _getCustomerInfo$data2, _getCustomerInfo$data3, _getCustomerInfo$data4, _documentDetailsGetBy31, _documentDetailsGetBy32, _documentDetailsGetBy33, _documentDetailsGetBy34, _documentDetailsGetBy35, _approvalData$SourceM9, _approvalData$SourceM10;
    var rbacControl = useRbacController('/jobCard');
    var trackButtonClick = useAnalyticsEventTracker("EstimateDetailsView");
    var getDocumentByIDURL = props.getDocumentByIDURL, headerTitle = props.headerTitle, headerBackClick = props.headerBackClick, parentDocument = props.parentDocument, createAndEditFlow = props.createAndEditFlow;
    var dispatch = useAppDispatch();
    var _a = useParams(), documentId = _a.documentId, parentId = _a.parentId, inspection = _a.inspection, RevisedEstimate = _a.RevisedEstimate, jobCardId = _a.jobCardId;
    var navigate = useNavigate();
    var _b = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _b.documentDetailsGetById, signature = _b.signature, getCustomerInfo = _b.getCustomerInfo, additionalEstimateDetail = _b.additionalEstimateDetail, JCCreateStartTime = _b.JCCreateStartTime, EstimateCreateStartTime = _b.EstimateCreateStartTime, approveEstimate = _b.approveEstimate;
    var vehicleDetails = documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data;
    var _c = useSelector(function (state) { return state.common; }), updatedModuleSectionByChannel = _c.updatedModuleSectionByChannel, precheckSectionDetails = _c.precheckSectionDetails;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var _d = useState(0), labourCostToShowonUI = _d[0], setLabourCostToShowOnUI = _d[1];
    var _e = useState(0), partCostToShowonUI = _e[0], setPartCostToShowOnUI = _e[1];
    var _f = useState(false), enableShareOption = _f[0], setEnableShareOption = _f[1];
    var _g = useState({
        additionalJobs: [],
        standardJobs: [],
        periodicJobs: [],
        roadTestData: []
    }), allJobs = _g[0], setAllJobs = _g[1];
    var _h = useState({
        //This data contains only the data received from the API on page load and if any section is saved then it will be saved in this state
        additionalJobs: [],
        standardJobs: [],
        periodicJobs: [],
        roadTestData: []
    }), allSavedJobs = _h[0], setAllSavedJobs = _h[1];
    var _j = useState(true), isPrintLoading = _j[0], setIsPrintLoading = _j[1];
    var _k = useState(false), isPrintOpen = _k[0], setIsPrintOpen = _k[1];
    var _l = useState(0), totalEstimateCostToShowonUI = _l[0], setTotalEstimateCostToShowonUI = _l[1];
    var _m = useState(0), estimateCost = _m[0], setEstimateCost = _m[1];
    var _o = useState(false), editCustomer = _o[0], setEditCustomer = _o[1];
    var _p = useState({
        Name: "InPerson"
    }), markApprovalType = _p[0], setMarkApprovalType = _p[1];
    var _q = useState([]), markApprovalList = _q[0], setMarkApprovalList = _q[1];
    var _r = useState(''), selectedDate = _r[0], setSelectedDate = _r[1];
    var _s = useState(""), inPersonImage = _s[0], setInPersonImage = _s[1];
    var _t = useState(false), showJobCardSubmitPopup = _t[0], setShowJobCardSubmitPopup = _t[1];
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var _u = useState([]), menus = _u[0], setMenus = _u[1];
    var _v = useState(null), anchorEl = _v[0], setAnchorEl = _v[1];
    var _w = useState(false), cancelPopup = _w[0], setCancelPopup = _w[1];
    var _x = useState(''), estimateCode = _x[0], setEstimateCode = _x[1];
    var _y = useState(false), cancelledSuccessfulPopup = _y[0], setCancelledSuccessfulPopup = _y[1];
    var _z = useState([]), approvalData = _z[0], setApprovalData = _z[1];
    var _0 = useState([]), approveEstimateData = _0[0], setApproveEstimateData = _0[1];
    var _1 = useState(true), isShowSkeleton = _1[0], setShowSkeleton = _1[1];
    var _2 = useState(false), openPopup = _2[0], setOpenPopup = _2[1];
    var _3 = useState(false), hasUnsavedChanges = _3[0], setHasUnsavedChanges = _3[1];
    var _4 = useState(false), timeError = _4[0], setTimeError = _4[1];
    var _5 = useState([]), periodicPartData = _5[0], setPeriodicPartData = _5[1];
    var _6 = useState(null), periodicSkeleton = _6[0], setPeriodicSkeleton = _6[1];
    var _7 = useState([]), standardData = _7[0], setStandardJobData = _7[1];
    var _8 = useState(null), standardSkeleton = _8[0], setStandardSkeleton = _8[1];
    var _9 = useState([]), additionalJobDataRes = _9[0], setAdditionalJobDataRes = _9[1];
    var _10 = useState(null), additionalJobSkeleton = _10[0], setAdditionalJobSkeleton = _10[1];
    var _11 = useState([]), additionalJobsFromAPI = _11[0], setAdditionalJobsFromAPI = _11[1];
    var _12 = useState(true), areAllDeclined = _12[0], setAreAllDeclined = _12[1];
    var state = useLocation().state;
    var open = Boolean(anchorEl);
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var orgnizationTimings = getLocalStorageItem(LOCAL_STORAGE_KEYS.ORGANIZATION_TIMING);
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up('md'); });
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var _13 = useState(null), previousJobcardRepeat = _13[0], setPreviousJobcardRepeat = _13[1];
    var isDisabled = [StatusEnum.Approved, StatusEnum.ApprovalPending, StatusEnum.Cancelled, StatusEnum.Closed, StatusEnum.Converted].includes((documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.Key) || "") || (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FinalInspector;
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var _14 = useState([]), fuelIdicatorDynamicList = _14[0], setFuelIndicatorDynamicList = _14[1];
    var _15 = useState([]), scratchList = _15[0], setScratchList = _15[1];
    var _16 = useState([]), damageList = _16[0], setdamageList = _16[1];
    var _17 = useState([]), missingList = _17[0], setMissingList = _17[1];
    var _18 = useState(''), precheckRemarks = _18[0], setPrecheckRemarks = _18[1];
    var _19 = useState(''), selectedPrecheckValue = _19[0], setSelectedPrecheckValue = _19[1];
    var _20 = useState([]), precheckImageList = _20[0], setPrecheckimageList = _20[1];
    var _21 = useState(false), isAssignModalOpen = _21[0], setIsAssignModalOpen = _21[1];
    var _22 = useState(""), assignValue = _22[0], setAssignValue = _22[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var storedSelectedChannel = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var storedSelectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var socketRoom = "".concat(storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId, "_").concat(storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId);
    var socket = null;
    socket = socketIO;
    useEffect(function () {
        if (socket && storedSelectedChannel !== null && storedSelectedChannel !== void 0 && storedSelectedChannel.ChannelId && storedSelectedBranch !== null && storedSelectedBranch !== void 0 && storedSelectedBranch.OrganizationId) {
            if (!socket.connected) {
                socket.connect();
            }
            socket.emit("joinRoom", socketRoom);
            socket.on("disconnect", function () {
                console.log("socket disconnected estimate details");
            });
            return function () {
                // console.log("Cleaning up listener");
                socket.off("PreJobCardUpdate");
                socket.disconnect();
            };
        }
    }, []);
    useEffect(function () {
        if (socket && documentDetailsGetById && documentDetailsGetById.data) {
            var _socket;
            (_socket = socket) === null || _socket === void 0 || _socket.on('PreJobCardUpdate', function (data) {
                console.log("data", data);
                if (data.PreJobCardDocumentId === documentId) {
                    var updatedDocumentDetails = _objectSpread({}, documentDetailsGetById);
                    var updateData = _objectSpread(_objectSpread({}, updatedDocumentDetails === null || updatedDocumentDetails === void 0 ? void 0 : updatedDocumentDetails.data), data);
                    updateData.StatusName = data === null || data === void 0 ? void 0 : data.StatusName;
                    updateData.SourceDocumentNo = data !== null && data !== void 0 && data.SourceDocumentNo ? data === null || data === void 0 ? void 0 : data.SourceDocumentNo : updateData.SourceDocumentNo;
                    updateData.Key = data === null || data === void 0 ? void 0 : data.Key;
                    var updatedSourceMessage = _objectSpread({}, updateData.SourceMessage);
                    updatedSourceMessage.ErrorMessage = data.ErrorMessage;
                    updateData.SourceMessage = updatedSourceMessage;
                    updatedDocumentDetails.data = updateData;
                    console.log("updatedDocumentDetails", updatedDocumentDetails);
                    dispatch(setState({
                        key: "documentDetailsGetById",
                        value: updatedDocumentDetails
                    }));
                }
            });
        }
    }, [socket, documentDetailsGetById]);
    // console.log("socket", socket);
    useEffect(function () {
        scrollToTop();
        documentDetailsDetails();
        getMarkApprovalList();
        dispatch(setState({
            key: "signature",
            value: ""
        }));
        dispatch(setState({
            key: "preDocumentFetch",
            value: []
        }));
    }, []);
    useEffect(function () {
        if (documentDetailsGetById && documentDetailsGetById !== null && documentDetailsGetById !== void 0 && documentDetailsGetById.data) {
            var _documentDetailsGetBy2, _documentDetailsGetBy3, _documentDetailsGetBy4;
            var previousJobcardBody = {
                InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.InstallBaseId,
                Status: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy3 = documentDetailsGetById.data) !== null && _documentDetailsGetBy3 !== void 0 && _documentDetailsGetBy3.Key ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.Key : null
            };
            dispatch(createAPI({
                key: "previousJobCards",
                url: previousJobCardURLForRepeat,
                request: previousJobcardBody
            })).then(function (result) {
                var previousJcItem = result && result.payload && result.payload.value && result.payload.value.success && result.payload.value.data && Array.isArray(result.payload.value.data) && result.payload.value.data[0] ? result.payload.value.data[0] : null;
                setPreviousJobcardRepeat(previousJcItem);
            });
            if (!RevisedEstimate && documentId) {
                getFuelLevel();
                getSABoxData(documentId);
            }
        }
    }, [documentDetailsGetById]);
    useEffect(function () {
        if (additionalEstimateDetail) {
            setAdditionalJobDataRes(additionalEstimateDetail.additionalJobList);
            setAdditionalJobSkeleton(additionalEstimateDetail.SkeletonView);
        }
    }, [additionalEstimateDetail]);
    useEffect(function () {
        if (precheckSectionDetails) {
            var _getprecheckSectionAt;
            if (!((_getprecheckSectionAt = getprecheckSectionAttributes(precheckSectionDetails)) !== null && _getprecheckSectionAt !== void 0 && (_getprecheckSectionAt = _getprecheckSectionAt.PRODUCT_CONDITION_SECTION_ATTRIBUTES) !== null && _getprecheckSectionAt !== void 0 && _getprecheckSectionAt.HIDE)) {
                getPrecheck();
            }
        }
    }, [precheckSectionDetails]);
    var estimateFetures = getCTAList(storedAllMenuFeatures, EMenuNames.ServiceEstimate);
    var getPrecheckAnswersByModelId = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestBody, answersResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        EstimateId: documentId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + 'Estimate', "/InspectionPreCheckList"),
                            request: requestBody
                        }))];
                case 1:
                    answersResponse = _a.sent();
                    if (answersResponse.payload.success) {
                        return [2 /*return*/, answersResponse.payload.data.Options];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getSABoxData = function (vehicleInspectionId) { return __awaiter(_this, void 0, void 0, function () {
        var _responseData$payload, _responseData$payload2, _responseData$payload3, responseData, _responseData$payload4, _responseData$payload5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: '',
                        url: "".concat(Config.baseURL, "PreJobCardDocument/").concat(vehicleInspectionId, "/SAPreCheckComments")
                    }))];
                case 1:
                    responseData = _a.sent();
                    if (responseData !== null && responseData !== void 0 && (_responseData$payload = responseData.payload) !== null && _responseData$payload !== void 0 && _responseData$payload.success && responseData !== null && responseData !== void 0 && (_responseData$payload2 = responseData.payload) !== null && _responseData$payload2 !== void 0 && _responseData$payload2.data && responseData !== null && responseData !== void 0 && (_responseData$payload3 = responseData.payload) !== null && _responseData$payload3 !== void 0 && (_responseData$payload3 = _responseData$payload3.data) !== null && _responseData$payload3 !== void 0 && _responseData$payload3.SAComments) {
                        setPrecheckRemarks((_responseData$payload4 = responseData === null || responseData === void 0 || (_responseData$payload5 = responseData.payload) === null || _responseData$payload5 === void 0 || (_responseData$payload5 = _responseData$payload5.data) === null || _responseData$payload5 === void 0 || (_responseData$payload5 = _responseData$payload5.SAComments) === null || _responseData$payload5 === void 0 ? void 0 : _responseData$payload5.Comments) !== null && _responseData$payload4 !== void 0 ? _responseData$payload4 : '');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getFuelLevel = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy5, productAttributeBody, productAttributeResult, fuelAttributeValue, _documentDetailsGetBy6, requestBody, QuestionsResponse, QuestionsList, questionsAnswers_1, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!documentId) return [3 /*break*/, 4];
                    productAttributeBody = {
                        "ProductId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.ProductId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: productAttributeValueUrl,
                            request: productAttributeBody
                        }))];
                case 1:
                    productAttributeResult = _a.sent();
                    if (!(productAttributeResult.payload.value.success && productAttributeResult.payload.value.data)) return [3 /*break*/, 4];
                    fuelAttributeValue = productAttributeResult.payload.value.data.Value;
                    if (!fuelAttributeValue) return [3 /*break*/, 4];
                    requestBody = {
                        "SystemName": "FuelUsed-".concat(fuelAttributeValue),
                        "ProductId": documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.ProductId,
                        "OrganizationId": storedSelectedBranch === null || storedSelectedBranch === void 0 ? void 0 : storedSelectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 2:
                    QuestionsResponse = _a.sent();
                    if (!QuestionsResponse.payload.value.success) return [3 /*break*/, 4];
                    QuestionsList = QuestionsResponse.payload.value.data;
                    return [4 /*yield*/, getPrecheckAnswersByModelId()];
                case 3:
                    questionsAnswers_1 = _a.sent();
                    result = QuestionsList.map(function (questionGroupItem) {
                        if (questionGroupItem.Questions && questionGroupItem.Questions.length > 0) {
                            var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                Questions: SortedQuestionsBySequence.map(function (questionItem) {
                                    // const questionControlType = controlTypesList.find((item: any) => item.id === questionItem.ControlId);
                                    var questionAnswerItem = questionsAnswers_1.find(function (item) { return item.QuestionId === questionItem.QuestionId; });
                                    return _objectSpread(_objectSpread({}, questionItem), {}, {
                                        // ControlName: questionControlType && questionControlType.DisplayName ? questionControlType.DisplayName : '',
                                        ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : ''
                                    });
                                })
                            });
                        }
                    });
                    setFuelIndicatorDynamicList(result);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getPrecheck = function () { return __awaiter(_this, void 0, void 0, function () {
        var _precheckListResult$p, _precheckListResult$p2, request, precheckListResult, _precheckListResult$p3, _precheckListResult$p4, result, imageAttachementURLs, downloadPromise, Scraches_1, Damages_1, Missings_1;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        EstimateId: documentId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getEstimateProductContitionValuesUrl,
                            request: request
                        }))];
                case 1:
                    precheckListResult = _a.sent();
                    if (!(precheckListResult !== null && precheckListResult !== void 0 && (_precheckListResult$p = precheckListResult.payload) !== null && _precheckListResult$p !== void 0 && _precheckListResult$p.success && precheckListResult !== null && precheckListResult !== void 0 && (_precheckListResult$p2 = precheckListResult.payload) !== null && _precheckListResult$p2 !== void 0 && _precheckListResult$p2.data)) return [3 /*break*/, 3];
                    result = precheckListResult === null || precheckListResult === void 0 || (_precheckListResult$p3 = precheckListResult.payload) === null || _precheckListResult$p3 === void 0 || (_precheckListResult$p3 = _precheckListResult$p3.data) === null || _precheckListResult$p3 === void 0 ? void 0 : _precheckListResult$p3.InspectionValues;
                    imageAttachementURLs = [];
                    downloadPromise = precheckListResult === null || precheckListResult === void 0 || (_precheckListResult$p4 = precheckListResult.payload) === null || _precheckListResult$p4 === void 0 || (_precheckListResult$p4 = _precheckListResult$p4.data) === null || _precheckListResult$p4 === void 0 ? void 0 : _precheckListResult$p4.ImageAttachments.map(function (imageItem) { return __awaiter(_this, void 0, void 0, function () {
                        var base64, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, imageItem.id, getDownloadPreJobCardDocumentAttachmentUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    imageAttachementURLs.push(base64);
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.error(error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadPromise)];
                case 2:
                    _a.sent();
                    setPrecheckimageList(imageAttachementURLs);
                    Scraches_1 = [];
                    Damages_1 = [];
                    Missings_1 = [];
                    result.forEach(function (element) {
                        if ((element === null || element === void 0 ? void 0 : element.AnswerKey) === "Scratch") {
                            Scraches_1.push(element);
                        }
                        else if ((element === null || element === void 0 ? void 0 : element.AnswerKey) === "Damage") {
                            Damages_1.push(element);
                        }
                        else if ((element === null || element === void 0 ? void 0 : element.AnswerKey) === "Missing") {
                            Missings_1.push(element);
                        }
                    });
                    setScratchList(Scraches_1);
                    setdamageList(Damages_1);
                    setMissingList(Missings_1);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var documentDetailsDetails = function () { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload, result, _result$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "documentDetailsGetById",
                            url: getDocumentByIDURL + documentId + "/Get"
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.success) {
                        setShowSkeleton(false);
                        // setAccordianAPICall(true)
                        if ((result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.value) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.data) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.Key) === "Approved") {
                            setMenus(estimateFetures);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleBackClick = function () {
        if (hasUnsavedChanges) {
            setOpenPopup(true);
        }
        else {
            var _documentDetailsGetBy7;
            headerBackClick(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy7 = documentDetailsGetById.data) === null || _documentDetailsGetBy7 === void 0 ? void 0 : _documentDetailsGetBy7.StatusName);
        }
    };
    var setAdditionalJobsByAPI = function (additionJobsByAPI) {
        setAdditionalJobsFromAPI(additionJobsByAPI);
    };
    var setCostValue = function (labourCost, partCost, cost, autoPopulateLabourCost, autoPopulatePartCost, declinedAdditionalJobs) {
        setEstimateCost(cost + autoPopulateLabourCost + autoPopulatePartCost);
        setLabourCostToShowOnUI(labourCost);
        setPartCostToShowOnUI(partCost);
        setTotalEstimateCostToShowonUI(cost);
        var allDeclinedFlag = areAllExpanded(additionalJobsFromAPI, declinedAdditionalJobs);
        if (allDeclinedFlag) {
            setAreAllDeclined(true);
        }
        else {
            setAreAllDeclined(false);
        }
    };
    var areAllExpanded = function (original, updated) {
        var updatedMap = updated.reduce(function (map, item) {
            map[item.ChildId] = item.isExpanded;
            return map;
        }, {});
        for (var _i = 0, original_1 = original; _i < original_1.length; _i++) {
            var item = original_1[_i];
            if (updatedMap[item.ChildId] !== undefined) {
                if (item.isExpanded !== updatedMap[item.ChildId]) {
                    return false;
                }
            }
        }
        return true;
    };
    var getSignatureImg = function (value) {
        console.log("signature :: ", value);
    };
    var approvalType = function (value) {
        setMarkApprovalType(value);
        setHasUnsavedChanges(true);
    };
    var onSelectedDate = function (value, context) {
        setSelectedDate(value);
        setHasUnsavedChanges(true);
        if (context !== null && context !== void 0 && context.validationError && (context === null || context === void 0 ? void 0 : context.validationError) == "disablePast") {
            setTimeError(true);
        }
        else {
            setTimeError(false);
        }
    };
    var setCanvasImage = function () {
        setInPersonImage("");
    };
    var getMarkApprovalList = function () { return __awaiter(_this, void 0, void 0, function () {
        var approvalTypeList, _response$payload, _response$payload2, response, _response$payload3, inPersonType, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    approvalTypeList = getLocalStorageItem(LOCAL_STORAGE_KEYS.APPROVAL_TYPE_LIST);
                    if (!!approvalTypeList) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getInspectionApprovalTypeUrl
                        }))];
                case 1:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) == 200 || response !== null && response !== void 0 && (_response$payload2 = response.payload) !== null && _response$payload2 !== void 0 && _response$payload2.success) {
                        approvalTypeList = response === null || response === void 0 || (_response$payload3 = response.payload) === null || _response$payload3 === void 0 ? void 0 : _response$payload3.data;
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.APPROVAL_TYPE_LIST, approvalTypeList);
                    }
                    _a.label = 2;
                case 2:
                    inPersonType = approvalTypeList.find(function (item) { return item.Name = "InPerson"; });
                    if (inPersonType) {
                        setMarkApprovalType(inPersonType);
                    }
                    return [4 /*yield*/, setMarkApprovalList(approvalTypeList)];
                case 3:
                    _a.sent();
                    getEstimateAdditionalDetailByEstimateId(approvalTypeList);
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("Error-", e_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getEstimateAdditionalDetailByEstimateId = function (list) { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload4, _response$payload5, request, response, _response$payload6, data_1, findData, base64, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        EstimateId: documentId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getEstimateAdditionalDetailByEstimateIdUrl,
                            request: request
                        }))];
                case 1:
                    response = _a.sent();
                    if (!((response === null || response === void 0 || (_response$payload4 = response.payload) === null || _response$payload4 === void 0 ? void 0 : _response$payload4.statusCode) == 200 || response !== null && response !== void 0 && (_response$payload5 = response.payload) !== null && _response$payload5 !== void 0 && _response$payload5.success)) return [3 /*break*/, 6];
                    data_1 = response === null || response === void 0 || (_response$payload6 = response.payload) === null || _response$payload6 === void 0 ? void 0 : _response$payload6.data;
                    findData = list.find(function (element) { return (element === null || element === void 0 ? void 0 : element.id) == (data_1 === null || data_1 === void 0 ? void 0 : data_1.InspectionApprovalTypeId); });
                    if (!(data_1 !== null && data_1 !== void 0 && data_1.AttachmentId && data_1 !== null && data_1 !== void 0 && data_1.PreJobCardDocumentAttachmentId)) return [3 /*break*/, 5];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, downloadAttachment(data_1 === null || data_1 === void 0 ? void 0 : data_1.AttachmentId, data_1 === null || data_1 === void 0 ? void 0 : data_1.PreJobCardDocumentAttachmentId, getDownloadPreJobCardDocumentAttachmentUrl)];
                case 3:
                    base64 = _a.sent();
                    // const base64: any = await downloadAttachment('9351b9e9-3b45-4fe2-8604-924724007716','f297ba85-942f-43a9-9c40-7165c12b308b', getDownloadPreJobCardDocumentAttachmentUrl);
                    setInPersonImage(base64);
                    dispatch(setState({
                        key: "signature",
                        value: base64
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 5:
                    if (data_1 !== null && data_1 !== void 0 && data_1.LabourPrice && data_1 !== null && data_1 !== void 0 && data_1.PartPrice) {
                        setEstimateCost((data_1 === null || data_1 === void 0 ? void 0 : data_1.PartPrice) + (data_1 === null || data_1 === void 0 ? void 0 : data_1.LabourPrice));
                    }
                    if (findData) {
                        setMarkApprovalType(findData);
                        setHasUnsavedChanges(true);
                    }
                    if (data_1 !== null && data_1 !== void 0 && data_1.EstimatedDeliveryDate) {
                        setSelectedDate(data_1 === null || data_1 === void 0 ? void 0 : data_1.EstimatedDeliveryDate);
                        setHasUnsavedChanges(true);
                    }
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onBackButtonClick = function () {
        navigate("/serviceEstimate");
    };
    var isTriumph = (storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelName) === E_Channel_Name.Triumph;
    var onSaveClick = function () {
        trackButtonClick("ButtonClickEvent", "Save_Estimate_Details", undefined);
        setHasUnsavedChanges(false);
        if (!areAllDeclined) {
            GoogleAnlyticsErrorLog(profileData, 'ClientSide', t("Please save additional job changes."));
            dispatch(showNotification({
                isOpen: true,
                message: t("Please save additional job changes."),
                type: "error"
            }));
            return;
        }
        var messageArray = [];
        if (periodicPartData.length > 0) {
            var periodicPrice = periodicPartData === null || periodicPartData === void 0 ? void 0 : periodicPartData.filter(function (item) { return item.SelectedPriceDetails.Amount === 0 && !item.isExpanded; });
            var displayName_1 = updatedModuleSectionByChannel.find(function (item) { return item.Key == EModuleSection.PeriodicMaintenance; });
            // if (periodicPrice.length > 0) {
            //   const finalObject = periodicPrice?.map((item) => {
            //     return ({ message: item?.LabourName || item?.PartName || item?.ChildName, groupName: displayName.DisplayName ?? "" })
            //   })
            //   messageArray.push(finalObject)
            // }
            if (periodicPrice.length > 0) {
                var finalObject = periodicPrice === null || periodicPrice === void 0 ? void 0 : periodicPrice.flatMap(function (item) {
                    if (item !== null && item !== void 0 && item.LabourName || item !== null && item !== void 0 && item.LabourCode) {
                        var _displayName$DisplayN;
                        return {
                            message: item === null || item === void 0 ? void 0 : item.LabourName,
                            groupName: (_displayName$DisplayN = displayName_1.DisplayName) !== null && _displayName$DisplayN !== void 0 ? _displayName$DisplayN : ""
                        };
                    }
                    return [];
                });
                messageArray.push.apply(messageArray, finalObject);
            }
        }
        if (additionalJobDataRes.length > 0) {
            // const additionalPrice = additionalJobDataRes?.filter((item: any) => (item.SelectedPriceDetails.Amount === undefined || item.SelectedPriceDetails.Amount === null || item.SelectedPriceDetails.Amount === 0) && !item.isExpanded && !(isTriumph && item.jobType === "Part"))
            var additionalPrice = additionalJobDataRes === null || additionalJobDataRes === void 0 ? void 0 : additionalJobDataRes.filter(function (item) { return (item.SelectedPriceDetails.Amount === undefined || item.SelectedPriceDetails.Amount === null || item.SelectedPriceDetails.Amount === 0) && !item.isExpanded && item.jobType !== "Part"; });
            // const additionalPrice = additionalJobDataRes?.filter((item) => item.SelectedPriceDetails.Amount == 0 && !item.isExpanded && item.AutofillType !== 2)
            var displayName_2 = updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.find(function (item) { return item.Key == EModuleSection.AdditionalJobs; });
            // if (additionalPrice.length > 0) {
            //   const finalObject = additionalPrice?.map((item) => {
            //     return ({ message: item?.LabourName, groupName: displayName.DisplayName ?? "" })
            //   })
            //   messageArray.push(finalObject)
            // }
            if (additionalPrice.length > 0) {
                var finalObject = additionalPrice === null || additionalPrice === void 0 ? void 0 : additionalPrice.flatMap(function (item) {
                    if (item !== null && item !== void 0 && item.LabourName || item !== null && item !== void 0 && item.LabourCode) {
                        var _displayName$DisplayN2;
                        return {
                            message: item === null || item === void 0 ? void 0 : item.LabourName,
                            groupName: (_displayName$DisplayN2 = displayName_2.DisplayName) !== null && _displayName$DisplayN2 !== void 0 ? _displayName$DisplayN2 : ""
                        };
                    }
                    return [];
                });
                messageArray.push.apply(messageArray, finalObject);
            }
        }
        if (standardData.length > 0) {
            var displayName_3 = updatedModuleSectionByChannel.find(function (item) { return item.Key == EModuleSection.StandardJobs; });
            var standardPriceZero = standardData.filter(function (item) {
                var _item$SelectedPriceDe, _item$SelectedPriceDe2, _item$SelectedPriceDe3;
                return (((_item$SelectedPriceDe = item.SelectedPriceDetails) === null || _item$SelectedPriceDe === void 0 ? void 0 : _item$SelectedPriceDe.Amount) === undefined || ((_item$SelectedPriceDe2 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe2 === void 0 ? void 0 : _item$SelectedPriceDe2.Amount) === null || ((_item$SelectedPriceDe3 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe3 === void 0 ? void 0 : _item$SelectedPriceDe3.Amount) === 0) && !item.isExpanded && (item.LabourName || (item === null || item === void 0 ? void 0 : item.LabourCode));
            });
            console.log("standardPriceZero", standardPriceZero);
            if (standardPriceZero.length > 0) {
                var finalObject = standardPriceZero.map(function (item) {
                    var _displayName$DisplayN3;
                    return {
                        message: (item === null || item === void 0 ? void 0 : item.LabourName) || (item === null || item === void 0 ? void 0 : item.PartName) || (item === null || item === void 0 ? void 0 : item.ChildName),
                        groupName: (_displayName$DisplayN3 = displayName_3 === null || displayName_3 === void 0 ? void 0 : displayName_3.DisplayName) !== null && _displayName$DisplayN3 !== void 0 ? _displayName$DisplayN3 : ""
                    };
                });
                messageArray.push(finalObject);
            }
        }
        var finalMessageArray = messageArray === null || messageArray === void 0 ? void 0 : messageArray.flat();
        if (finalMessageArray.length > 0) {
            // const combinedMessage = finalMessageArray.map((obj : any) => obj.message);
            GoogleAnlyticsErrorLog(profileData, 'ClientSide', /*#__PURE__*/ React.createElement("p", null, t("Price for each selected items must be greater than zero"), /*#__PURE__*/ React.createElement("br", null), finalMessageArray.map(function (p, index) {
                return /*#__PURE__*/ React.createElement("p", null, index + 1, ".", p.message, " : ", p.groupName, " ");
            })));
            dispatch(showNotification({
                isOpen: true,
                message: /*#__PURE__*/ React.createElement("p", null, t("Price for each selected items must be greater than zero"), /*#__PURE__*/ React.createElement("br", null), finalMessageArray.map(function (p, index) {
                    return /*#__PURE__*/ React.createElement("p", null, index + 1, ".", p.message, " : ", p.groupName, " ");
                })),
                type: "error"
            }));
            return;
        }
        var partsWithAutoFillType2 = additionalJobDataRes === null || additionalJobDataRes === void 0 ? void 0 : additionalJobDataRes.filter(function (item) { return item.AutofillType === 2 && item.Type === "Part" && !item.isAutoFillType2Removed; });
        // if (estimateCost > 0) {
        if (selectedDate === "") {
            GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please select estimated delivery date");
            dispatch(showNotification({
                isOpen: true,
                message: "Please select estimated delivery date",
                type: "error"
            }));
            return;
        }
        if (orgnizationTimings !== null && orgnizationTimings !== void 0 && orgnizationTimings.StartDateTime && orgnizationTimings !== null && orgnizationTimings !== void 0 && orgnizationTimings.EndDateTime) {
            var betweenOpeningAndClosing = minutesOfDay(new Date(orgnizationTimings === null || orgnizationTimings === void 0 ? void 0 : orgnizationTimings.StartDateTime)) <= minutesOfDay(new Date(selectedDate)) && minutesOfDay(new Date(orgnizationTimings === null || orgnizationTimings === void 0 ? void 0 : orgnizationTimings.EndDateTime)) >= minutesOfDay(new Date(selectedDate));
            if (!betweenOpeningAndClosing) {
                GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please select time slot within workshop working hours");
                dispatch(showNotification({
                    isOpen: true,
                    message: "Estimated delivery time should be within workshop working hours.",
                    type: "error"
                }));
                return;
            }
        }
        if ((markApprovalType === null || markApprovalType === void 0 ? void 0 : markApprovalType.Name) === "Select") {
            GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please select approval type");
            dispatch(showNotification({
                isOpen: true,
                message: "Please select approval type",
                type: "error"
            }));
            return;
        }
        if ((markApprovalType === null || markApprovalType === void 0 ? void 0 : markApprovalType.Name) === "InPerson" && signature === "") {
            GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Please add signature");
            dispatch(showNotification({
                isOpen: true,
                message: "Please add signature",
                type: "error"
            }));
            return;
        }
        onSaveSeviveEstimateClick();
        // }
        // else {
        //   GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Estimated cost cannot be 0")
        //   dispatch(
        //     showNotification({
        //       isOpen: true,
        //       message: "Estimated cost cannot be 0",
        //       type: "error",
        //     })
        //   );
        // }
        // const result = calculateTimeDifference(JCCreateStartTime?.date, new Date());
        // let eventName = `${parentDocument}` + `_${getEstimateSaveButtonName()}` + `_Click`
        // window.gtag('event', eventName, {
        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
        //   'date': new Date() + profileData?.data?.IdentityId,
        //   'createJCDuration': `${result.hours}h ${result.minutes}m ${result.seconds}s ${result.milliseconds}ms` + `: ${profileData?.data?.IdentityId}`
        // });
    };
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var createServiceEstimate = function () {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function () {
            var _calculateEstimateCos, _calculateEstimateCos2, _result$payload3, attachmentId, requestBody, result, _result$payload4, _result$payload5, _result$payload6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attachmentId = arguments_1.length > 0 && arguments_1[0] !== undefined ? arguments_1[0] : "";
                        requestBody = {
                            EstimateId: documentId,
                            PartPrice: Number((_calculateEstimateCos = calculateEstimateCost(allSavedJobs, allSavedJobs.roadTestData)) === null || _calculateEstimateCos === void 0 ? void 0 : _calculateEstimateCos.partCost.toFixed(2)),
                            LabourPrice: Number((_calculateEstimateCos2 = calculateEstimateCost(allSavedJobs, allSavedJobs.roadTestData)) === null || _calculateEstimateCos2 === void 0 ? void 0 : _calculateEstimateCos2.labourCost.toFixed(2)),
                            InspectionApprovalTypeId: markApprovalType === null || markApprovalType === void 0 ? void 0 : markApprovalType.id,
                            EstimatedDeliveryDate: selectedDate,
                            OrganizationId: UserOrganization,
                            BALEstimateSyncType: RevisedEstimate ? 'RevisedEstimate' : 'Estimate'
                        };
                        if (attachmentId != "") {
                            requestBody = _objectSpread(_objectSpread({}, requestBody), {
                                AttachmentId: attachmentId
                            });
                        }
                        return [4 /*yield*/, dispatch(createAPI({
                                key: "",
                                url: estimateCreateUrl,
                                request: requestBody
                            }))];
                    case 1:
                        result = _a.sent();
                        if (result !== null && result !== void 0 && (_result$payload3 = result.payload) !== null && _result$payload3 !== void 0 && _result$payload3.success) {
                            // setShowJobCardSubmitPopup(true);
                            setApprovalData(result === null || result === void 0 || (_result$payload4 = result.payload) === null || _result$payload4 === void 0 ? void 0 : _result$payload4.data);
                            if ((result === null || result === void 0 || (_result$payload5 = result.payload) === null || _result$payload5 === void 0 || (_result$payload5 = _result$payload5.data) === null || _result$payload5 === void 0 ? void 0 : _result$payload5.ReferenceId) != null || (result === null || result === void 0 || (_result$payload6 = result.payload) === null || _result$payload6 === void 0 || (_result$payload6 = _result$payload6.data) === null || _result$payload6 === void 0 ? void 0 : _result$payload6.SourceDocumentNo) != null) {
                                setEnableShareOption(true);
                                approvalEstimateCall();
                            }
                            else {
                                setShowJobCardSubmitPopup(true);
                            }
                        }
                        else {
                            // buttonClickSpan.end();
                            // pageLoadSpan.end();
                            // transaction.end();
                            dispatch(showLoader({
                                isLoaderOpen: false
                            }));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var approvalEstimateCall = function () { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload7, response, _response$error, _response$error2, _profileData$data, _profileData$data2, _profileData$data3, _profileData$data4, _profileData$data5, _profileData$data6, _profileData$data7, _profileData$data8, _profileData$data9, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, dispatch(updateAPI({
                        key: "approveEstimate",
                        url: approvalEstimate(documentId)
                    }))];
                case 1:
                    response = _b.sent();
                    setApproveEstimateData(response === null || response === void 0 ? void 0 : response.payload);
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (response !== null && response !== void 0 && response.error) {
                        GoogleAnlyticsErrorLog(profileData, approvalEstimate(documentId), (_response$error = response.error) === null || _response$error === void 0 ? void 0 : _response$error.message);
                        dispatch(showNotification({
                            isOpen: true,
                            message: (_response$error2 = response.error) === null || _response$error2 === void 0 ? void 0 : _response$error2.message,
                            type: "error"
                        }));
                    }
                    else if (response !== null && response !== void 0 && (_response$payload7 = response.payload) !== null && _response$payload7 !== void 0 && _response$payload7.success) {
                        result = calculateTimeDifference((EstimateCreateStartTime === null || EstimateCreateStartTime === void 0 ? void 0 : EstimateCreateStartTime.date) || (JCCreateStartTime === null || JCCreateStartTime === void 0 ? void 0 : JCCreateStartTime.date), new Date());
                        // mixpanel.track(`${headerTitle}_${getEstimateSaveButtonName()}_Click` + ` / ${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` / ${profileData?.data?.IdentityId}`, {
                        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                        //   'date': new Date() + profileData?.data?.IdentityId,
                        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                        //   'mode': 'Edit',
                        //   'documentId': documentId,
                        //   [`${EstimateCreateStartTime?.date ? 'createEstimateDuration' : 'createJobCardDuration'}`]: `${result?.hours}h ${result?.minutes}m ${result?.seconds}s ${result?.milliseconds}ms` + `: ${profileData?.data?.IdentityId}`
                        //   // 'navigateTo': 'ServiceEstimate Details Page'
                        // });
                        // window.gtag(
                        //   'event', `${headerTitle}_${getEstimateSaveButtonName()}_Click`, {
                        //   'id': profileData?.data?.IdentityId,          // Transaction ID.
                        //   'name': `${profileData?.data?.GivenName}` + ` ${profileData?.data?.FamilyName}` + ` ${profileData?.data?.IdentityId}`,
                        //   'code': `${profileData?.data?.Code}` + ` ${profileData?.data?.IdentityId}`,
                        //   'date': new Date() + profileData?.data?.IdentityId,
                        //   'path': `${window.location.href}` + ` ${profileData?.data?.IdentityId}`,
                        //   'mode': 'Edit',
                        //   'documentId': documentId,
                        //   [`${EstimateCreateStartTime?.date ? 'createEstimateDuration' : 'createJobCardDuration'}`]: `${result?.hours}h ${result?.minutes}m ${result?.seconds}s ${result?.milliseconds}ms` + `: ${profileData?.data?.IdentityId}`
                        //   // 'navigateTo': 'ServiceEstimate Details Page'
                        // });
                        transactionEventLog("".concat(headerTitle, "_").concat(getEstimateSaveButtonName(), "_Click"), (_a = {
                                'id': profileData === null || profileData === void 0 || (_profileData$data = profileData.data) === null || _profileData$data === void 0 ? void 0 : _profileData$data.IdentityId,
                                // Transaction ID.
                                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data2 = profileData.data) === null || _profileData$data2 === void 0 ? void 0 : _profileData$data2.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data3 = profileData.data) === null || _profileData$data3 === void 0 ? void 0 : _profileData$data3.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data4 = profileData.data) === null || _profileData$data4 === void 0 ? void 0 : _profileData$data4.IdentityId),
                                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data5 = profileData.data) === null || _profileData$data5 === void 0 ? void 0 : _profileData$data5.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data6 = profileData.data) === null || _profileData$data6 === void 0 ? void 0 : _profileData$data6.IdentityId),
                                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data7 = profileData.data) === null || _profileData$data7 === void 0 ? void 0 : _profileData$data7.IdentityId),
                                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data8 = profileData.data) === null || _profileData$data8 === void 0 ? void 0 : _profileData$data8.IdentityId),
                                'mode': 'Edit',
                                'documentId': documentId
                            },
                            _a["".concat(EstimateCreateStartTime !== null && EstimateCreateStartTime !== void 0 && EstimateCreateStartTime.date ? 'createEstimateDuration' : 'createJobCardDuration')] = "".concat(result === null || result === void 0 ? void 0 : result.hours, "h ").concat(result === null || result === void 0 ? void 0 : result.minutes, "m ").concat(result === null || result === void 0 ? void 0 : result.seconds, "s ").concat(result === null || result === void 0 ? void 0 : result.milliseconds, "ms") + ": ".concat(profileData === null || profileData === void 0 || (_profileData$data9 = profileData.data) === null || _profileData$data9 === void 0 ? void 0 : _profileData$data9.IdentityId),
                            _a), profileData);
                        dispatch(setState({
                            key: "JCCreateStartTime",
                            value: {}
                        }));
                        dispatch(setState({
                            key: "EstimateCreateStartTime",
                            value: {}
                        }));
                        setShowJobCardSubmitPopup(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var onSaveSeviveEstimateClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var _response$payload8, _response$payload9, imageRequest, response, _response$payload$dat, _response$payload10, _response$payload11, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((markApprovalType === null || markApprovalType === void 0 ? void 0 : markApprovalType.Name) != InPerson)) return [3 /*break*/, 2];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, createServiceEstimate("")];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
                case 2:
                    if (!((markApprovalType === null || markApprovalType === void 0 ? void 0 : markApprovalType.Name) == InPerson && inPersonImage)) return [3 /*break*/, 4];
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, createServiceEstimate("")];
                case 3:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
                case 4:
                    _a.trys.push([4, 6, , 7]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    imageRequest = {
                        ParentId: documentId,
                        ImageAttachments: [{
                                SystemName: "Estimate",
                                MediaType: 1
                            }]
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: createAttachment,
                            request: imageRequest
                        }))];
                case 5:
                    response = _a.sent();
                    if ((response === null || response === void 0 || (_response$payload8 = response.payload) === null || _response$payload8 === void 0 ? void 0 : _response$payload8.statusCode) == 201 && response !== null && response !== void 0 && (_response$payload9 = response.payload) !== null && _response$payload9 !== void 0 && _response$payload9.success) {
                        uploadSignature((_response$payload$dat = response === null || response === void 0 || (_response$payload10 = response.payload) === null || _response$payload10 === void 0 || (_response$payload10 = _response$payload10.data[0]) === null || _response$payload10 === void 0 ? void 0 : _response$payload10.PreJobCardDocumentAttachmentId) !== null && _response$payload$dat !== void 0 ? _response$payload$dat : response === null || response === void 0 || (_response$payload11 = response.payload) === null || _response$payload11 === void 0 || (_response$payload11 = _response$payload11.data[0]) === null || _response$payload11 === void 0 ? void 0 : _response$payload11.id);
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    return [3 /*break*/, 7];
                case 6:
                    error_3 = _a.sent();
                    console.log(error_3);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var dataURLtoFile = function (dataurl, filename) { return __awaiter(_this, void 0, void 0, function () {
        var _arr$, arr, mime, 
        // bstr = Buffer.from(arr[arr.length - 1], 'base64').toString(),
        bstr, n, u8arr;
        return __generator(this, function (_a) {
            arr = dataurl.split(","), mime = (_arr$ = arr[0]) === null || _arr$ === void 0 || (_arr$ = _arr$.match(/:(.*?);/)) === null || _arr$ === void 0 ? void 0 : _arr$[1], bstr = atob(arr[arr.length - 1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return [2 /*return*/, new File([u8arr], filename, {
                    type: mime
                })];
        });
    }); };
    var uploadSignature = function (id) { return __awaiter(_this, void 0, void 0, function () {
        var file, formData, result, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 6, , 7]);
                    return [4 /*yield*/, dataURLtoFile(signature, "sign.png")];
                case 1:
                    file = _a.sent();
                    formData = new FormData();
                    formData.append("data", file);
                    return [4 /*yield*/, UploadImage(UploadedSignAttachmentUrl(id), formData, "EstimateAdditionalDetail", dispatch)];
                case 2:
                    result = _a.sent();
                    if (!(result !== null && result !== void 0 && result.statusCode || result !== null && result !== void 0 && result.success)) return [3 /*break*/, 3];
                    createServiceEstimate(result === null || result === void 0 ? void 0 : result.attachmentId);
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: false
                    }))];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    error_4 = _a.sent();
                    console.log("error ", error_4);
                    return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var handleYesJobCardSubmitClick = function () {
        setShowJobCardSubmitPopup(false);
        if (RevisedEstimate) {
            var _approvalData$SourceM, _profileData$data10, _profileData$data11, _profileData$data12, _profileData$data13, _profileData$data14, _profileData$data15, _profileData$data16, _profileData$data17;
            transactionEventLog("".concat(headerTitle, "_").concat((approvalData === null || approvalData === void 0 || (_approvalData$SourceM = approvalData.SourceMessage) === null || _approvalData$SourceM === void 0 ? void 0 : _approvalData$SourceM.ErrorCode) == "ERR_GO0002" && (approvalData.ReferenceId == null || approvalData.SourceDocumentNo == null) ? t("View Estimate") : RevisedEstimate ? t("View_Job_Card") : t("SUBMIT_JC_BUTTON"), "_Yes_Button_Click"), {
                'id': profileData === null || profileData === void 0 || (_profileData$data10 = profileData.data) === null || _profileData$data10 === void 0 ? void 0 : _profileData$data10.IdentityId,
                // Transaction ID.
                'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data11 = profileData.data) === null || _profileData$data11 === void 0 ? void 0 : _profileData$data11.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data12 = profileData.data) === null || _profileData$data12 === void 0 ? void 0 : _profileData$data12.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data13 = profileData.data) === null || _profileData$data13 === void 0 ? void 0 : _profileData$data13.IdentityId),
                'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data14 = profileData.data) === null || _profileData$data14 === void 0 ? void 0 : _profileData$data14.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data15 = profileData.data) === null || _profileData$data15 === void 0 ? void 0 : _profileData$data15.IdentityId),
                'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data16 = profileData.data) === null || _profileData$data16 === void 0 ? void 0 : _profileData$data16.IdentityId),
                'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data17 = profileData.data) === null || _profileData$data17 === void 0 ? void 0 : _profileData$data17.IdentityId),
                'mode': 'Edit',
                'documentId': jobCardId,
                'navigateTo': 'Jobcard Details Page'
            }, profileData);
            navigate("/jobcard-details/".concat(jobCardId));
        }
        else {
            var _approvalData$SourceM2;
            if ((approvalData === null || approvalData === void 0 ? void 0 : approvalData.key) == StatusEnum.Error || (approvalData === null || approvalData === void 0 || (_approvalData$SourceM2 = approvalData.SourceMessage) === null || _approvalData$SourceM2 === void 0 ? void 0 : _approvalData$SourceM2.ErrorCode) == "ERR_GO0002") {
                var _approvalData$SourceM3, _profileData$data18, _profileData$data19, _profileData$data20, _profileData$data21, _profileData$data22, _profileData$data23, _profileData$data24, _profileData$data25;
                transactionEventLog("".concat(headerTitle, "_").concat((approvalData === null || approvalData === void 0 || (_approvalData$SourceM3 = approvalData.SourceMessage) === null || _approvalData$SourceM3 === void 0 ? void 0 : _approvalData$SourceM3.ErrorCode) == "ERR_GO0002" && (approvalData.ReferenceId == null || approvalData.SourceDocumentNo == null) ? t("View Estimate") : RevisedEstimate ? t("View_Job_Card") : t("SUBMIT_JC_BUTTON"), "_Yes_Button_Click"), {
                    'id': profileData === null || profileData === void 0 || (_profileData$data18 = profileData.data) === null || _profileData$data18 === void 0 ? void 0 : _profileData$data18.IdentityId,
                    // Transaction ID.
                    'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data19 = profileData.data) === null || _profileData$data19 === void 0 ? void 0 : _profileData$data19.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data20 = profileData.data) === null || _profileData$data20 === void 0 ? void 0 : _profileData$data20.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data21 = profileData.data) === null || _profileData$data21 === void 0 ? void 0 : _profileData$data21.IdentityId),
                    'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data22 = profileData.data) === null || _profileData$data22 === void 0 ? void 0 : _profileData$data22.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data23 = profileData.data) === null || _profileData$data23 === void 0 ? void 0 : _profileData$data23.IdentityId),
                    'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data24 = profileData.data) === null || _profileData$data24 === void 0 ? void 0 : _profileData$data24.IdentityId),
                    'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data25 = profileData.data) === null || _profileData$data25 === void 0 ? void 0 : _profileData$data25.IdentityId),
                    'mode': 'Edit',
                    'documentId': documentDetailsGetById.data.EstimateId,
                    'navigateTo': 'ServiceEstimate Details Page'
                }, profileData);
                navigate("/serviceEstimate-details-created/".concat(documentDetailsGetById.data.EstimateId));
            }
            else {
                createJobcard();
            }
        }
    };
    var goToHomePage = function () {
        console.log("====", state);
        if (RevisedEstimate || (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) !== EUserRole.ServiceAdvisor) {
            navigate("/jobCard");
            return;
        }
        handleNoJobCardSubmitClick();
        if ((state === null || state === void 0 ? void 0 : state.fromRoute) === '/dashboard') {
            navigate(state === null || state === void 0 ? void 0 : state.fromRoute);
        }
        else {
            navigate("/serviceEstimate");
        }
    };
    var handleNoJobCardSubmitClick = function () {
        setShowJobCardSubmitPopup(false);
    };
    var createJobcard = function () { return __awaiter(_this, void 0, void 0, function () {
        var _documentDetailsGetBy8, _createJobCardRespons, _createJobCardRespons2, _approveEstimateData$, _approveEstimateData$2, _documentDetailsGetBy9, _approveEstimateData$3, _approveEstimateData$4, _documentDetailsGetBy10, _approveEstimateData$5, _approveEstimateData$6, _documentDetailsGetBy11, _validateServiceTypeR, validateServiceTypeResult, requestBody, createJobCardResponse, _approvalData$SourceM4, _profileData$data26, _profileData$data27, _profileData$data28, _profileData$data29, _profileData$data30, _profileData$data31, _profileData$data32, _profileData$data33, _createJobCardRespons3, _createJobCardRespons4, _createJobCardRespons5, reqt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!((approveEstimateData === null || approveEstimateData === void 0 ? void 0 : approveEstimateData.StatusName) === StatusEnum.Approved || (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy8 = documentDetailsGetById.data) === null || _documentDetailsGetBy8 === void 0 ? void 0 : _documentDetailsGetBy8.StatusName) === StatusEnum.Approved)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "serviceTypeValidateData",
                            url: ValidateServiceTypeURL,
                            request: {
                                "VinNo": (_approveEstimateData$ = approveEstimateData === null || approveEstimateData === void 0 || (_approveEstimateData$2 = approveEstimateData.data) === null || _approveEstimateData$2 === void 0 ? void 0 : _approveEstimateData$2.VinNo) !== null && _approveEstimateData$ !== void 0 ? _approveEstimateData$ : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy9 = documentDetailsGetById.data) === null || _documentDetailsGetBy9 === void 0 ? void 0 : _documentDetailsGetBy9.VinNo,
                                "RepairTypeId": (_approveEstimateData$3 = approveEstimateData === null || approveEstimateData === void 0 || (_approveEstimateData$4 = approveEstimateData.data) === null || _approveEstimateData$4 === void 0 ? void 0 : _approveEstimateData$4.RepairTypeId) !== null && _approveEstimateData$3 !== void 0 ? _approveEstimateData$3 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy10 = documentDetailsGetById.data) === null || _documentDetailsGetBy10 === void 0 ? void 0 : _documentDetailsGetBy10.RepairTypeId,
                                "Usage": (_approveEstimateData$5 = approveEstimateData === null || approveEstimateData === void 0 || (_approveEstimateData$6 = approveEstimateData.data) === null || _approveEstimateData$6 === void 0 ? void 0 : _approveEstimateData$6.ODOMeterReading) !== null && _approveEstimateData$5 !== void 0 ? _approveEstimateData$5 : documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy11 = documentDetailsGetById.data) === null || _documentDetailsGetBy11 === void 0 ? void 0 : _documentDetailsGetBy11.ODOMeterReading,
                                "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                            }
                        }))];
                case 1:
                    validateServiceTypeResult = _a.sent();
                    if ((validateServiceTypeResult === null || validateServiceTypeResult === void 0 || (_validateServiceTypeR = validateServiceTypeResult.payload) === null || _validateServiceTypeR === void 0 || (_validateServiceTypeR = _validateServiceTypeR.value) === null || _validateServiceTypeR === void 0 ? void 0 : _validateServiceTypeR.statusCode) !== 200)
                        return [2 /*return*/];
                    _a.label = 2;
                case 2:
                    requestBody = {
                        EstimateId: documentId
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: createJobcardURL,
                            request: requestBody
                        }))];
                case 3:
                    createJobCardResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (createJobCardResponse !== null && createJobCardResponse !== void 0 && (_createJobCardRespons = createJobCardResponse.payload) !== null && _createJobCardRespons !== void 0 && _createJobCardRespons.success && (createJobCardResponse === null || createJobCardResponse === void 0 || (_createJobCardRespons2 = createJobCardResponse.payload) === null || _createJobCardRespons2 === void 0 ? void 0 : _createJobCardRespons2.statusCode) == 201) {
                        dispatch(setState({
                            key: "documentDetailsGetById",
                            value: {}
                        }));
                        transactionEventLog("".concat(headerTitle, "_").concat((approvalData === null || approvalData === void 0 || (_approvalData$SourceM4 = approvalData.SourceMessage) === null || _approvalData$SourceM4 === void 0 ? void 0 : _approvalData$SourceM4.ErrorCode) == "ERR_GO0002" && (approvalData.ReferenceId == null || approvalData.SourceDocumentNo == null) ? t("View Estimate") : RevisedEstimate ? t("View_Job_Card") : t("SUBMIT_JC_BUTTON"), "_Yes_Button_Click"), {
                            'id': profileData === null || profileData === void 0 || (_profileData$data26 = profileData.data) === null || _profileData$data26 === void 0 ? void 0 : _profileData$data26.IdentityId,
                            // Transaction ID.
                            'name': "".concat(profileData === null || profileData === void 0 || (_profileData$data27 = profileData.data) === null || _profileData$data27 === void 0 ? void 0 : _profileData$data27.GivenName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data28 = profileData.data) === null || _profileData$data28 === void 0 ? void 0 : _profileData$data28.FamilyName) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data29 = profileData.data) === null || _profileData$data29 === void 0 ? void 0 : _profileData$data29.IdentityId),
                            'code': "".concat(profileData === null || profileData === void 0 || (_profileData$data30 = profileData.data) === null || _profileData$data30 === void 0 ? void 0 : _profileData$data30.Code) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data31 = profileData.data) === null || _profileData$data31 === void 0 ? void 0 : _profileData$data31.IdentityId),
                            'date': new Date() + (profileData === null || profileData === void 0 || (_profileData$data32 = profileData.data) === null || _profileData$data32 === void 0 ? void 0 : _profileData$data32.IdentityId),
                            'path': "".concat(window.location.href) + " ".concat(profileData === null || profileData === void 0 || (_profileData$data33 = profileData.data) === null || _profileData$data33 === void 0 ? void 0 : _profileData$data33.IdentityId),
                            'mode': 'Edit',
                            'documentId': createJobCardResponse.payload.data.JobCardId,
                            'navigateTo': 'Jobcard Details Page'
                        }, profileData);
                        reqt = {
                            ChannelId: storedSelectedChannel !== null && storedSelectedChannel !== void 0 && storedSelectedChannel.ChannelId ? storedSelectedChannel === null || storedSelectedChannel === void 0 ? void 0 : storedSelectedChannel.ChannelId : "",
                            ProductId: createJobCardResponse === null || createJobCardResponse === void 0 || (_createJobCardRespons3 = createJobCardResponse.payloaue) === null || _createJobCardRespons3 === void 0 || (_createJobCardRespons3 = _createJobCardRespons3.data) === null || _createJobCardRespons3 === void 0 ? void 0 : _createJobCardRespons3.ProductId,
                            Vin: createJobCardResponse === null || createJobCardResponse === void 0 || (_createJobCardRespons4 = createJobCardResponse.payloaue) === null || _createJobCardRespons4 === void 0 || (_createJobCardRespons4 = _createJobCardRespons4.data) === null || _createJobCardRespons4 === void 0 ? void 0 : _createJobCardRespons4.Vin,
                            InstallBaseId: createJobCardResponse === null || createJobCardResponse === void 0 || (_createJobCardRespons5 = createJobCardResponse.payloaue) === null || _createJobCardRespons5 === void 0 || (_createJobCardRespons5 = _createJobCardRespons5.data) === null || _createJobCardRespons5 === void 0 ? void 0 : _createJobCardRespons5.InstallBaseId,
                            TransactionDoc: "JobCard"
                            // ParentId:
                        };
                        // const resp = await checkHexFileAvailableAPI({ request: reqt })
                        navigate("/jobcard-details/".concat(createJobCardResponse.payload.data.JobCardId));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClick = function (event) {
        var _documentDetailsGetBy12;
        event.stopPropagation();
        var currStatus = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy12 = documentDetailsGetById.data) === null || _documentDetailsGetBy12 === void 0 ? void 0 : _documentDetailsGetBy12.Key;
        var statusesForCancelFeature = [StatusEnum.Created, StatusEnum.ApprovalPending];
        var cancelFeatureArray = [{
                DisplayName: 'Cancel',
                Name: 'Cancel'
            }];
        var features = estimateFetures;
        if (statusesForCancelFeature.includes(currStatus) || RevisedEstimate) {
            var _features, _features2;
            features = (_features = features) === null || _features === void 0 ? void 0 : _features.filter(function (x) { return (x === null || x === void 0 ? void 0 : x.Name) === EMenuFeature.Cancel; });
            if (!((_features2 = features) !== null && _features2 !== void 0 && _features2.length))
                features = cancelFeatureArray;
        }
        if (vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.SourceDocumentNo || vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.Code) {
            features.push(printFeature);
        }
        setMenus(features);
        setAnchorEl(event.currentTarget);
    };
    var onSEPrintMoreClick = function (event) {
        event.stopPropagation();
        setMenus([printFeature]);
        setAnchorEl(event.currentTarget);
    };
    var handlePrintClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setIsPrintOpen(true);
            return [2 /*return*/];
        });
    }); };
    var handleMenusClick = function (data) {
        if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.Cancel) {
            setCancelPopup(true);
        }
        else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.CreateJobCard) {
            createJobcard();
        }
        else if ((data === null || data === void 0 ? void 0 : data.Name) === EMenuFeature.AssignServiceAdvisor) {
            setIsAssignModalOpen(true);
            setAssignValue(data === null || data === void 0 ? void 0 : data.Name);
        }
        else if ((data === null || data === void 0 ? void 0 : data.Name) === 'Print') {
            handlePrintClick();
        }
    };
    var onCancelPopupClick = function (value) {
        setCancelPopup(value);
        setAnchorEl(null);
    };
    var onCancelServiceEstimateClick = function (result) { return __awaiter(_this, void 0, void 0, function () {
        var _result$payload7, _result$payload8, _result$payload9;
        return __generator(this, function (_a) {
            if ((result === null || result === void 0 || (_result$payload7 = result.payload) === null || _result$payload7 === void 0 ? void 0 : _result$payload7.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload8 = result.payload) !== null && _result$payload8 !== void 0 && _result$payload8.success) {
                onCancelPopupClick(false);
                setEstimateCode((_result$payload9 = result.payload) === null || _result$payload9 === void 0 || (_result$payload9 = _result$payload9.data) === null || _result$payload9 === void 0 ? void 0 : _result$payload9.Code);
                setCancelledSuccessfulPopup(true);
            }
            ;
            return [2 /*return*/];
        });
    }); };
    var handleClose = function (event) {
        event.stopPropagation();
        setAnchorEl(null);
    };
    var headerIcon = function (compareKey) {
        var _approvalData$SourceM5, _approvalData$SourceM6;
        if ((approvalData === null || approvalData === void 0 || (_approvalData$SourceM5 = approvalData.SourceMessage) === null || _approvalData$SourceM5 === void 0 ? void 0 : _approvalData$SourceM5.ErrorCode) == "ERR_GO0002" && ((approvalData === null || approvalData === void 0 ? void 0 : approvalData.ReferenceId) == null || (approvalData === null || approvalData === void 0 ? void 0 : approvalData.SourceDocumentNo) == null)) {
            if (compareKey == "icon") {
                return AlertRedIcon;
            }
            else if (compareKey == "header") {
                return t("Error received from CDMS");
            }
            else if (compareKey == "subHeader") {
                return t("Please correct the error in service estimate to create Job Card");
            }
        }
        else if ((approvalData === null || approvalData === void 0 || (_approvalData$SourceM6 = approvalData.SourceMessage) === null || _approvalData$SourceM6 === void 0 ? void 0 : _approvalData$SourceM6.ErrorCode) == "ERR_GO0001" && ((approvalData === null || approvalData === void 0 ? void 0 : approvalData.ReferenceId) == null || (approvalData === null || approvalData === void 0 ? void 0 : approvalData.SourceDocumentNo) == null)) {
            if (compareKey == "icon") {
                return WarningIcon;
            }
            else if (compareKey == "header") {
                return t('Awaiting CDMS confirmation');
            }
            else if (compareKey == "subHeader") {
                return t("Please wait for the confirmation from CDMS to create Job Card");
            }
        }
        else if (approvalData.ReferenceId != null || approvalData.SourceDocumentNo != null) {
            if (RevisedEstimate) {
                if (compareKey == "icon") {
                    return SuccessIconNew;
                }
                else if (compareKey == "header") {
                    return t("Revised estimate approved!");
                }
            }
            else {
                if (compareKey == "icon") {
                    return SuccessIconNew;
                }
                else if (compareKey == "header") {
                    return t("ESTIMATE_SUCCESSFULLY_MSG");
                }
            }
        }
    };
    var onErrorCallbackOne = function (error) {
        console.log("one parentPP", error);
        setTimeError(true);
    };
    var disableSave = function () {
        if (isDisabled || timeError) {
            return true;
        }
        var validateMessage = "";
        var validAll = [];
        if (updatedModuleSectionByChannel.length > 0) {
            updatedModuleSectionByChannel.map(function (item) {
                var _item$SectionAttribut, _item$SectionAttribut2, _item$SectionAttribut3;
                validateMessage = "Please save ".concat(item === null || item === void 0 ? void 0 : item.DisplayName);
                switch (item.Key) {
                    case EModuleSection.PeriodicMaintenance:
                        if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && item !== null && item !== void 0 && (_item$SectionAttribut = item.SectionAttributes[0]) !== null && _item$SectionAttribut !== void 0 && _item$SectionAttribut.HIDE) {
                            validAll.push("true");
                        }
                        else {
                            if (periodicSkeleton) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        break;
                    case EModuleSection.StandardJobs:
                        if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && item !== null && item !== void 0 && (_item$SectionAttribut2 = item.SectionAttributes[0]) !== null && _item$SectionAttribut2 !== void 0 && _item$SectionAttribut2.HIDE) {
                            validAll.push("true");
                        }
                        else {
                            if (standardSkeleton) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        break;
                    case EModuleSection.AdditionalJobs:
                        if (item !== null && item !== void 0 && item.SectionAttributes && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && item !== null && item !== void 0 && (_item$SectionAttribut3 = item.SectionAttributes[0]) !== null && _item$SectionAttribut3 !== void 0 && _item$SectionAttribut3.HIDE) {
                            validAll.push("true");
                        }
                        else {
                            if (additionalJobSkeleton) {
                                validAll.push("true");
                            }
                            else {
                                validAll.push("false");
                            }
                        }
                        break;
                    default:
                        validAll.push("true");
                        break;
                }
            });
            var all_true = validAll.every(function (item) { return item === "true"; });
            return !all_true;
        }
        else {
            return true;
        }
    };
    var additionalJobDataFunction = function (value, skeleton) {
        setAdditionalJobDataRes(value);
        setAdditionalJobSkeleton(skeleton);
    };
    var getEstimateSaveButtonName = function () {
        if (RevisedEstimate) {
            return t("GENERATE_REVISE_ESTIMATE");
        }
        else {
            if (inspection) {
                return t('MARK_APPROVAL');
            }
            else {
                return t("Save");
            }
        }
    };
    var buttonName = getEstimateSaveButtonName();
    var isMarkApprovalButton = buttonName === t('MARK_APPROVAL');
    var listVariants = [{
            id: 1,
            Name: 'General',
            DisplayName: 'General'
        }, {
            id: 2,
            Name: 'TaskDetails',
            DisplayName: 'Task Details'
        }, {
            id: 3,
            Name: 'Summary',
            DisplayName: 'Summary'
        }];
    var valuetext = function (value) {
        return "".concat(value, " %");
    };
    var onClickYesBtn = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setOpenPopup(false);
            return [2 /*return*/];
        });
    }); };
    var savedTotalEstimateCost = function () {
        var cost = calculateEstimateCost(allSavedJobs, allSavedJobs.roadTestData).cost;
        return cost;
    };
    var onClickNoBtn = function () {
        navigate(-1);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        width: '100%',
        bgcolor: systemColor.backgroundColor
    }, /*#__PURE__*/ React.createElement(HeaderDetails, {
        headerTitle: headerTitle,
        status: (_documentDetailsGetBy13 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy14 = documentDetailsGetById.data) === null || _documentDetailsGetBy14 === void 0 ? void 0 : _documentDetailsGetBy14.StatusName) !== null && _documentDetailsGetBy13 !== void 0 ? _documentDetailsGetBy13 : "",
        docDate: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy15 = documentDetailsGetById.data) === null || _documentDetailsGetBy15 === void 0 ? void 0 : _documentDetailsGetBy15.ScheduledDate,
        docNo: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy16 = documentDetailsGetById.data) === null || _documentDetailsGetBy16 === void 0 ? void 0 : _documentDetailsGetBy16.Code,
        sourceDocumentNo: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy17 = documentDetailsGetById.data) !== null && _documentDetailsGetBy17 !== void 0 && _documentDetailsGetBy17.SourceDocumentNo ? documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy18 = documentDetailsGetById.data) === null || _documentDetailsGetBy18 === void 0 ? void 0 : _documentDetailsGetBy18.SourceDocumentNo : "",
        onHandleClick: handleBackClick,
        onMoreIconClick: handleClick,
        onSEPrintMoreClick: vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.SourceDocumentNo || vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.Code ? onSEPrintMoreClick : undefined,
        parentComponent: EParentModuleName.ServiceEstimate,
        statusKey: (_documentDetailsGetBy19 = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy20 = documentDetailsGetById.data) === null || _documentDetailsGetBy20 === void 0 ? void 0 : _documentDetailsGetBy20.Key) !== null && _documentDetailsGetBy19 !== void 0 ? _documentDetailsGetBy19 : '',
        IsRevisedEstimate: ((_documentDetailsGetBy21 = documentDetailsGetById.data) === null || _documentDetailsGetBy21 === void 0 ? void 0 : _documentDetailsGetBy21.EstimateType) === "RevisedEstimate",
        isFromIspection: Module == isModuleConfig.Bajaj ? inspection : false
        // isShowMoreIcon={menus?.length > 0 ? true : false}
    }), !isShowSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, " ", (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy22 = documentDetailsGetById.data) === null || _documentDetailsGetBy22 === void 0 || (_documentDetailsGetBy22 = _documentDetailsGetBy22.SourceMessage) === null || _documentDetailsGetBy22 === void 0 ? void 0 : _documentDetailsGetBy22.ErrorMessage) && /*#__PURE__*/ React.createElement(Alert, {
        style: {
            "padding": "0 16px",
            marginBottom: "5px"
        },
        variant: "outlined",
        severity: "error"
    }, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy23 = documentDetailsGetById.data) === null || _documentDetailsGetBy23 === void 0 || (_documentDetailsGetBy23 = _documentDetailsGetBy23.SourceMessage) === null || _documentDetailsGetBy23 === void 0 ? void 0 : _documentDetailsGetBy23.ErrorMessage)), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column"
    }, (documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && /*#__PURE__*/ React.createElement(OptionAlert, {
        documentStatusKey: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy24 = documentDetailsGetById.data) === null || _documentDetailsGetBy24 === void 0 ? void 0 : _documentDetailsGetBy24.Key,
        jobCardId: documentId !== null && documentId !== void 0 ? documentId : "",
        JobcardNo: "",
        difference: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy25 = documentDetailsGetById.data) !== null && _documentDetailsGetBy25 !== void 0 && _documentDetailsGetBy25.EstimateDeliveryDateTime ? moment().diff(moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy26 = documentDetailsGetById.data) === null || _documentDetailsGetBy26 === void 0 ? void 0 : _documentDetailsGetBy26.EstimateDeliveryDateTime), 'minutes') : 0,
        EstimatedDateTime: documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy27 = documentDetailsGetById.data) !== null && _documentDetailsGetBy27 !== void 0 && _documentDetailsGetBy27.EstimateDeliveryDateTime ? moment(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy28 = documentDetailsGetById.data) === null || _documentDetailsGetBy28 === void 0 ? void 0 : _documentDetailsGetBy28.EstimateDeliveryDateTime).format('DD MMM, YYYY - h:mm A') : "",
        previousJobcard: previousJobcardRepeat,
        InstallBaseId: documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy29 = documentDetailsGetById.data) === null || _documentDetailsGetBy29 === void 0 ? void 0 : _documentDetailsGetBy29.InstallBaseId,
        isCreateDocumentFlow: false,
        isDocumentDisabled: isDisabled
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        md: 12,
        paddingX: 2,
        lg: 12,
        xl: 12,
        p: 2
    }, /*#__PURE__*/ React.createElement("div", {
        style: {
            border: "1px solid ".concat(systemColor.grey),
            marginRight: '-15px',
            marginLeft: '-15px'
        }
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        px: 2,
        pb: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: "column",
        bgcolor: systemColor.white,
        px: 1.5,
        border: "1px solid ".concat(systemColor.grey),
        borderRadius: '12px',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(CustomerAndVehicleInfo, {
        VehiclesDetailsList: documentDetailsGetById ? [documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data] : [],
        customerDetails: documentDetailsGetById ? documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data : {},
        isCheckBoxVisible: false,
        parentDocument: parentDocument,
        isDisabled: isDisabled,
        createAndEditFlow: {
            isEstimate: "Update"
        }
    }))), editCustomer && (documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && /*#__PURE__*/ React.createElement(EditCustomerInfo, {
        open: editCustomer,
        onClose: function () { return setEditCustomer(function (prev) { return !prev; }); },
        data: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        isDisabled: true
    }), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 1,
        padding: 2,
        paddingTop: 0
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 7.4,
        lg: 7.4,
        xl: 7.4
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2,
        direction: 'column'
    }, (documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data) && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        direction: "column",
        bgcolor: systemColor.white,
        border: "1px solid ".concat(systemColor.grey),
        borderRadius: '12px',
        spacing: 2,
        paddingTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        px: 2,
        variant: "h3",
        id: "Customer-vehicle-details"
    }, t("Estimate summary")), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MultipleAccordianCard, {
        setCostValue: setCostValue,
        setAdditionalJobsByAPI: setAdditionalJobsByAPI,
        totalEstimateCost: estimateCost,
        isDisabled: isDisabled,
        periodicPartDataCallBack: function (value, skeleton) {
            setAllSavedJobs(function (allJobs) {
                return _objectSpread(_objectSpread({}, allJobs), {}, {
                    periodicJobs: value
                });
            });
            setPeriodicPartData(value);
            setPeriodicSkeleton(skeleton);
        },
        standardJobDataCallback: function (value, skeleton) {
            setAllSavedJobs(function (allJobs) {
                return _objectSpread(_objectSpread({}, allJobs), {}, {
                    standardJobs: value
                });
            });
            setStandardJobData(value);
            setStandardSkeleton(skeleton);
        },
        additionalJobDataCallback: function (value, skeleton) {
            setAllSavedJobs(function (allJobs) {
                return _objectSpread(_objectSpread({}, allJobs), {}, {
                    additionalJobs: value
                });
            });
            additionalJobDataFunction(value, skeleton);
        },
        roadTestDataCallBack: function (value, skeleton) {
            setAllSavedJobs(function (allJobs) {
                return _objectSpread(_objectSpread({}, allJobs), {}, {
                    roadTestData: value
                });
            });
        },
        documentId: documentId,
        setAllJobs: setAllJobs,
        setIsPrintLoading: setIsPrintLoading,
        setHasUnsavedChanges: setHasUnsavedChanges,
        allJobs: allJobs,
        setAllSavedJobs: setAllSavedJobs
    })), updatedModuleSectionByChannel.length > 0 && (updatedModuleSectionByChannel === null || updatedModuleSectionByChannel === void 0 ? void 0 : updatedModuleSectionByChannel.map(function (item) {
        var _item$SectionAttribut4, _item$DisplayName, _getprecheckSectionAt2;
        return (item === null || item === void 0 ? void 0 : item.Key) == EModuleSection.Precheck && (item === null || item === void 0 ? void 0 : item.SectionAttributes.length) > 0 && !(item !== null && item !== void 0 && (_item$SectionAttribut4 = item.SectionAttributes[0]) !== null && _item$SectionAttribut4 !== void 0 && _item$SectionAttribut4.HIDE) && /*#__PURE__*/ React.createElement(MuiStack, {
            bgcolor: systemColor.white,
            borderRadius: '16px'
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            style: {
                border: '1px solid #DEE4EB',
                borderRadius: '12px'
            },
            direction: 'column',
            padding: 2,
            spacing: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            width: "100%",
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h2"
        }, " ", (_item$DisplayName = item.DisplayName) !== null && _item$DisplayName !== void 0 ? _item$DisplayName : "")), /*#__PURE__*/ React.createElement(MuiStack, {
            width: "100%",
            spacing: 2,
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            width: "100%"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h3"
        }, " ", t("Fuel/Battery Level"), " ")), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            direction: 'column',
            spacing: 4
        }, fuelIdicatorDynamicList.map(function (QuestionGroupItem, QuestionGroupItemIndex) {
            return /*#__PURE__*/ React.createElement(MuiStack, {
                direction: 'column',
                width: '100%',
                key: QuestionGroupItemIndex,
                spacing: isDesktop ? 6 : 3
            }, QuestionGroupItem.Questions.map(function (QuestionItem, QuestionItemIndex) {
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    sx: {
                        width: '100%'
                    },
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    sx: {
                        width: '60%'
                    }
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h4"
                }, QuestionItem.Title, " ")), /*#__PURE__*/ React.createElement(MuiStack, {
                    sx: {
                        width: '40%'
                    },
                    alignItems: 'center',
                    spacing: 2
                }, /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h4"
                }, "E"), /*#__PURE__*/ React.createElement(Slider, {
                    sx: {
                        width: "50%",
                        padding: '10px',
                        color: systemColor.primary,
                        '& .MuiSlider-valueLabel ': {
                            bgcolor: systemColor.primary
                        }
                    },
                    "aria-label": "Temperature",
                    getAriaValueText: valuetext,
                    valueLabelFormat: valuetext,
                    valueLabelDisplay: "on",
                    step: 20,
                    min: 0,
                    max: 100,
                    value: Number(QuestionItem.ResponseValue)
                }), /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h4"
                }, "F")));
            }));
        }))), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiBorderBottom, null), !((_getprecheckSectionAt2 = getprecheckSectionAttributes(precheckSectionDetails)) !== null && _getprecheckSectionAt2 !== void 0 && (_getprecheckSectionAt2 = _getprecheckSectionAt2.PRODUCT_CONDITION_SECTION_ATTRIBUTES) !== null && _getprecheckSectionAt2 !== void 0 && _getprecheckSectionAt2.HIDE) && /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'space-between',
            textAlign: 'center',
            sx: {
                border: '1px solid #DEE4EB',
                borderRadius: '8px'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                width: '33%',
                padding: '8px',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                borderRight: '1px solid #DEE4EB',
                marginLeft: '2px',
                backgroundColor: selectedPrecheckValue === 'Scratch' ? '#F4F7FA' : '#fff',
                color: selectedPrecheckValue === 'Scratch' ? systemColor.primary : '#6A7682'
            }
            //onClick={() => onPrecheckClick('Scratch')}
        }, /*#__PURE__*/ React.createElement(Typography, {
            color: gray,
            variant: "h3",
            style: {
                fontSize: isDesktop ? '12px' : '16px'
            }
        }, t('Scratch')), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '7px',
            height: "18px",
            sx: {
                border: '1px solid #DEE4EB',
                borderRadius: '12px',
                backgroundColor: '#F4F7FA',
                padding: '12px',
                marginLeft: '3px',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "scratchCount",
            style: {
                fontWeight: '500',
                fontSize: isDesktop ? '10px' : '12px',
                color: '#1B1D21'
            }
        }, scratchList.length))), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                width: '33%',
                padding: '8px',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                borderRight: '1px solid #DEE4EB',
                backgroundColor: selectedPrecheckValue === 'Damage' ? '#F4F7FA' : '#fff',
                color: selectedPrecheckValue === 'Damage' ? systemColor.primary : '#6A7682'
            }
            //onClick={() => onPrecheckClick('Damage')}
        }, /*#__PURE__*/ React.createElement(Typography, {
            color: gray,
            variant: "h3",
            style: {
                fontSize: isDesktop ? '13px' : '16px'
            }
        }, t('Damage')), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '7px',
            height: "18px",
            sx: {
                border: '1px solid #DEE4EB',
                borderRadius: '12px',
                backgroundColor: '#F4F7FA',
                padding: '12px',
                marginLeft: '3px',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "damageCount",
            style: {
                fontWeight: '500',
                fontSize: isDesktop ? '10px' : '12px',
                color: '#1B1D21'
            }
        }, damageList.length))), /*#__PURE__*/ React.createElement(MuiStack, {
            sx: {
                width: '33%',
                padding: '8px',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '2px',
                backgroundColor: selectedPrecheckValue === 'Missing' ? '#F4F7FA' : '#fff',
                color: selectedPrecheckValue === 'Missing' ? systemColor.primary : '#6A7682'
            }
            //onClick={() => onPrecheckClick('Missing')}
        }, /*#__PURE__*/ React.createElement(Typography, {
            color: gray,
            variant: "h3",
            style: {
                fontSize: isDesktop ? '12px' : '16px'
            }
        }, t('Missing')), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '7px',
            height: "18px",
            sx: {
                border: '1px solid #DEE4EB',
                borderRadius: '12px',
                backgroundColor: '#F4F7FA',
                padding: '12px',
                marginLeft: '3px',
                boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
                alignItems: 'center',
                justifyContent: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "missingCount",
            style: {
                fontWeight: '500',
                fontSize: isDesktop ? '10px' : '12px',
                color: '#1B1D21'
            }
        }, missingList.length))))), precheckRemarks != '' && /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            paddingX: 1,
            border: '1px solid #DEE4EB',
            borderRadius: "8px",
            sx: {
                backgroundColor: '#F4F7FA',
                padding: '16px'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h4",
            color: "#1B1D21",
            sx: {
                lineBreak: 'anywhere'
            }
        }, precheckRemarks)))));
    })))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 12,
        md: 4.4,
        lg: 4.4,
        xl: 4.4,
        marginTop: isDesktop ? 0.5 : ''
    }, /*#__PURE__*/ React.createElement(ServiceEstimatePreCheckAndCustomerApproval, {
        labourCost: labourCostToShowonUI,
        partCost: partCostToShowonUI,
        estimateCost: totalEstimateCostToShowonUI,
        getSignatureImg: getSignatureImg,
        vehicleInspectionId: documentId,
        approvalType: approvalType,
        selectedItem: markApprovalType,
        markApprovalList: markApprovalList,
        onSelectedDate: onSelectedDate,
        selectedDate: selectedDate,
        inPersonImage: inPersonImage,
        setCanvasImage: setCanvasImage,
        isDisabled: isDisabled,
        timeError: timeError,
        isPreCheckVisible: false,
        isCostEstimationVisible: true,
        isSignatureVisible: true,
        isFromRevisedEstimate: RevisedEstimate,
        allJobs: allJobs,
        enableShareOption: enableShareOption,
        setHasUnsavedChanges: setHasUnsavedChanges
    }))), /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        direction: 'column',
        justifyContent: 'flex-end',
        bottom: 0,
        right: 0,
        width: '100%',
        bgcolor: '#FFFFFF'
    }, /*#__PURE__*/ React.createElement(MuiBorderBottom, null), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'flex-end',
        paddingX: 2,
        paddingBottom: 1
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        name: getEstimateSaveButtonName(),
        size: "large",
        variant: "contained",
        onClick: function () { return onSaveClick(); },
        id: "serviceEstimateCreateConfirmation",
        disabled: disableSave() || isMarkApprovalButton && (rbacControl === null || rbacControl === void 0 || (_rbacControl$MarkAppr = rbacControl.MarkApproval) === null || _rbacControl$MarkAppr === void 0 ? void 0 : _rbacControl$MarkAppr.disabled),
        sx: {
            display: isMarkApprovalButton && rbacControl !== null && rbacControl !== void 0 && (_rbacControl$MarkAppr2 = rbacControl.MarkApproval) !== null && _rbacControl$MarkAppr2 !== void 0 && _rbacControl$MarkAppr2.hidden ? 'none' : 'flex'
        }
    }))), /*#__PURE__*/ React.createElement(MuiPopup, {
        id: 'approvalConfirmationPopup',
        variant: "h1",
        openPopup: showJobCardSubmitPopup,
        onClose: goToHomePage,
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '500px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        },
        headerIcon: headerIcon("icon")
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "column",
        marginTop: 2
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h1"
    }, headerIcon("header")), approvalData.ReferenceId != null && approvalData.SourceDocumentNo != null && !inspection && /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row",
        marginTop: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#6A7682"
    }, t("Service estimate"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        id: "service-estimate-no",
        variant: "h6",
        color: "black",
        sx: {
            marginLeft: 0
        }
    }, documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy30 = documentDetailsGetById.data) === null || _documentDetailsGetBy30 === void 0 ? void 0 : _documentDetailsGetBy30.Code)), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h6",
        color: "#8593A3",
        marginTop: "10px"
    }, headerIcon("subHeader")), ((_approvalData$SourceM7 = approvalData.SourceMessage) === null || _approvalData$SourceM7 === void 0 ? void 0 : _approvalData$SourceM7.ErrorMessage) && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            border: "1px solid #F5222D",
            borderRadius: 2,
            padding: 2,
            marginY: 2
            // bgcolor: "#FFCCC7"
        },
        flexDirection: "row"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: "row"
    }, /*#__PURE__*/ React.createElement(InfoOutlinedIcon, {
        sx: {
            color: " #F5222D",
            marginRight: 1
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            wordBreak: "break-word"
        }
    }, " ", (_approvalData$SourceM8 = approvalData.SourceMessage) === null || _approvalData$SourceM8 === void 0 ? void 0 : _approvalData$SourceM8.ErrorMessage), " ")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: "#F5F7FA",
        padding: 2,
        borderRadius: 3
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        bgcolor: "#F5F7FA",
        spacing: 1,
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: '#8593A3',
            marginRight: '5px'
        }
    }, t("Customer Name") + ':'), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        id: "customer-name"
    }, getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data = getCustomerInfo.data) !== null && _getCustomerInfo$data !== void 0 && (_getCustomerInfo$data = _getCustomerInfo$data.Person) !== null && _getCustomerInfo$data !== void 0 && _getCustomerInfo$data.GivenName && getCustomerInfo !== null && getCustomerInfo !== void 0 && (_getCustomerInfo$data2 = getCustomerInfo.data) !== null && _getCustomerInfo$data2 !== void 0 && (_getCustomerInfo$data2 = _getCustomerInfo$data2.Person) !== null && _getCustomerInfo$data2 !== void 0 && _getCustomerInfo$data2.FamilyName ? "".concat(getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data3 = getCustomerInfo.data) === null || _getCustomerInfo$data3 === void 0 || (_getCustomerInfo$data3 = _getCustomerInfo$data3.Person) === null || _getCustomerInfo$data3 === void 0 ? void 0 : _getCustomerInfo$data3.GivenName, " ").concat(getCustomerInfo === null || getCustomerInfo === void 0 || (_getCustomerInfo$data4 = getCustomerInfo.data) === null || _getCustomerInfo$data4 === void 0 || (_getCustomerInfo$data4 = _getCustomerInfo$data4.Person) === null || _getCustomerInfo$data4 === void 0 ? void 0 : _getCustomerInfo$data4.FamilyName) : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: '#8593A3',
            marginRight: '5px'
        }
    }, t("Model")), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        id: "model-name"
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy31 = documentDetailsGetById.data) !== null && _documentDetailsGetBy31 !== void 0 && _documentDetailsGetBy31.ProductName ? "".concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy32 = documentDetailsGetById.data) === null || _documentDetailsGetBy32 === void 0 ? void 0 : _documentDetailsGetBy32.ProductName) : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        sx: {
            color: '#8593A3',
            marginRight: '5px'
        }
    }, t("Registration No") + ':'), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4",
        id: "reg-no"
    }, documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy33 = documentDetailsGetById.data) !== null && _documentDetailsGetBy33 !== void 0 && _documentDetailsGetBy33.RegistrationNo ? "".concat(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy34 = documentDetailsGetById.data) === null || _documentDetailsGetBy34 === void 0 ? void 0 : _documentDetailsGetBy34.RegistrationNo) : "-"))), /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, "".concat(t(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy35 = documentDetailsGetById.data) === null || _documentDetailsGetBy35 === void 0 ? void 0 : _documentDetailsGetBy35.RepairTypeName))), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            marginY: 2
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        flexDirection: 'column',
        gap: '12px'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between"
        // spacing={1}
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, "".concat(t("Total Estimated Cost"))), /*#__PURE__*/ React.createElement(Typography, {
        id: "TotalEstimateCost",
        variant: "h3"
    }, "\u20B9 ", savedTotalEstimateCost().toFixed(2))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        justifyContent: "space-between",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3"
    }, "".concat(t("ESTIMATE_DELIVERY_TIME"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "EstimateDeliveryTime",
        variant: "h3",
        align: "right"
    }, "".concat(dateFormate(selectedDate ? selectedDate : new Date()), " ").concat(getTime(new Date(selectedDate)))))))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: {
            xs: "column",
            sm: 'row-reverse'
        },
        spacing: 1.5,
        marginTop: 4
    }, (approvalData === null || approvalData === void 0 || (_approvalData$SourceM9 = approvalData.SourceMessage) === null || _approvalData$SourceM9 === void 0 ? void 0 : _approvalData$SourceM9.ErrorCode) != "ERR_GO0001" && /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        variant: "contained",
        size: "large",
        color: "primary",
        fullWidth: true,
        name: (approvalData === null || approvalData === void 0 || (_approvalData$SourceM10 = approvalData.SourceMessage) === null || _approvalData$SourceM10 === void 0 ? void 0 : _approvalData$SourceM10.ErrorCode) == "ERR_GO0002" && (approvalData.ReferenceId == null || approvalData.SourceDocumentNo == null) ? t("View Estimate") : RevisedEstimate ? t("View job card") : t("SUBMIT_JC_BUTTON"),
        onClick: handleYesJobCardSubmitClick,
        id: "serviceEstimateCreate"
    }), /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "Go to homepage",
        variant: "outlined",
        size: "large",
        color: "secondary",
        fullWidth: true,
        name: t("Go to homepage"),
        onClick: goToHomePage
    }))))))), /*#__PURE__*/ React.createElement(Menu, {
        id: "basic-menu",
        anchorEl: anchorEl,
        open: open,
        onClose: handleClose,
        disableScrollLock: true,
        MenuListProps: {
            "aria-labelledby": "basic-button",
            sx: {
                padding: 0
            }
        },
        slotProps: {
            paper: {
                sx: {
                    boxShadow: "0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)",
                    borderRadius: "8px",
                    border: "1px solid #DEE4EB",
                    right: 30,
                    width: 'fit-content'
                }
            }
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        minWidth: "270px"
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            minWidth: "270px",
            padding: 0
        }
    }, menus && (menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: item.Name,
            dense: true,
            key: index,
            sx: {
                width: "100%",
                height: "42px",
                borderBottom: index === menus.length - 1 ? "none" : "1px solid #DEE4EB",
                fontWeight: 500,
                fontSize: 14,
                fontFamily: "NotoSans-Medium",
                textTransform: 'capitalize'
            },
            onClick: function (event) {
                handleMenusClick(item);
                setAnchorEl(null);
            },
            disabled: item.Name === 'Print' && isPrintLoading
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
            }
        }, /*#__PURE__*/ React.createElement(Box, null, " ", item === null || item === void 0 ? void 0 : item.DisplayName), /*#__PURE__*/ React.createElement(Box, null, (item === null || item === void 0 ? void 0 : item.Name) === 'Print' && isPrintLoading && /*#__PURE__*/ React.createElement(CircularProgress, {
            size: 15,
            color: "inherit"
        }))));
    }))))), isShowSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        style: {
            height: '70vh',
            padding: "10px"
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), cancelPopup && /*#__PURE__*/ React.createElement(CancelDocumentModal, {
        cancelPopup: cancelPopup,
        data: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        title: t("Cancel service estimate"),
        subTitle: t("Are you sure you want to cancel this estimate? This action cannot be undone."),
        onCancelPopup: function (value) { return onCancelPopupClick(value); },
        onCancelClick: function (result) { return onCancelServiceEstimateClick(result); },
        SystemName: ECancelDocSystemName.Estimate
    }), cancelledSuccessfulPopup && /*#__PURE__*/ React.createElement(CancelSuccessfullyPopup, {
        documentCode: estimateCode,
        successfulPopup: cancelledSuccessfulPopup,
        onClosePopup: function (value) {
            setCancelledSuccessfulPopup(value);
            navigate("/serviceEstimate");
        },
        title: t('Successfully cancelled!'),
        subTitle: "Service estimate ".concat(estimateCode, " has been successfully cancelled")
    }), isPrintOpen && /*#__PURE__*/ React.createElement(NewServiceEstimatePrint, {
        data: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        allJobs: allJobs,
        inPersonImage: inPersonImage,
        isPrintLoading: isPrintLoading,
        onClose: function () {
            setIsPrintOpen(false);
        },
        open: isPrintOpen
    }), isAssignModalOpen && /*#__PURE__*/ React.createElement(AppointmentAssignReassignPopup, {
        isOpen: isAssignModalOpen,
        onClosed: function () {
            setIsAssignModalOpen(false);
            setAnchorEl(null);
        },
        data: assignValue,
        appointmentData: documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data,
        moduleName: EListCardView.ServiceEstimate
    }), /*#__PURE__*/ React.createElement(UnsavedChangesPopup, {
        isOpen: openPopup,
        onClosePopup: function (value) { return setOpenPopup(value); },
        onClickNoBtn: onClickNoBtn,
        onClickYesBtn: onClickYesBtn
    }));
}
